var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "../../services/customAxios"], function (require, exports, customAxios_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    customAxios_1 = __importDefault(customAxios_1);
    var LoginFlowRequest = (function () {
        function LoginFlowRequest() {
        }
        LoginFlowRequest.getValidationFields = function (route, pkErps, holderId) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4, customAxios_1.default.post(route + "/dados-validacao/" + holderId, pkErps)];
                        case 1: return [2, (_b = (_a = (_c.sent())) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data];
                    }
                });
            });
        };
        LoginFlowRequest.getValidationStatus = function (route, holderId) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4, customAxios_1.default.get(route + "/status-validacao/" + holderId)];
                        case 1: return [2, (_b = (_a = (_c.sent())) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data];
                    }
                });
            });
        };
        LoginFlowRequest.getValidationDocsStatus = function (route, holderId, operationCode) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                var queryParams;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            queryParams = "operationCode=" + operationCode;
                            return [4, customAxios_1.default.get(route + "/status-validacao-docs/" + holderId + "?" + queryParams)];
                        case 1: return [2, (_b = (_a = (_c.sent())) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data];
                    }
                });
            });
        };
        LoginFlowRequest.linkHolders = function (payload) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, customAxios_1.default.post('autosservico/titular/vincular-titular', payload)];
                        case 1: return [2, _a.sent()];
                    }
                });
            });
        };
        LoginFlowRequest.validateData = function (route, payload) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, customAxios_1.default.post(route + "/dados-validacao", payload)];
                        case 1: return [2, _a.sent()];
                    }
                });
            });
        };
        LoginFlowRequest.requestNewHoldersLink = function (route, holderId) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, customAxios_1.default.post(route + "/novos-vinculos/" + holderId)];
                        case 1: return [2, _a.sent()];
                    }
                });
            });
        };
        LoginFlowRequest.cancelNewHoldersLink = function (route, holderId) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, customAxios_1.default.post(route + "/cancelar-novos-vinculos/" + holderId)];
                        case 1: return [2, _a.sent()];
                    }
                });
            });
        };
        LoginFlowRequest.createNewDocsValidation = function (route, holderId, formData) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, customAxios_1.default.post(route + "/validacao-docs/" + holderId, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            })];
                        case 1: return [2, _a.sent()];
                    }
                });
            });
        };
        return LoginFlowRequest;
    }());
    exports.default = LoginFlowRequest;
});
